import { render, staticRenderFns } from "./Warhouses.vue?vue&type=template&id=29493f1a&scoped=true&"
import script from "./Warhouses.vue?vue&type=script&lang=js&"
export * from "./Warhouses.vue?vue&type=script&lang=js&"
import style0 from "./Warhouses.vue?vue&type=style&index=0&id=29493f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29493f1a",
  null
  
)

export default component.exports